import PayerCard from './PayerCard';

export default PayerCard;